import './PremiumTableHeader.scss';
import React from 'react';

const PremiumTableHeader = ({}) => {
  return (
    <>
      <div className={'pa-premium-table-header'}>
        <div className="cell">Underwriter</div>
        <div className={'cell'}>Scheme</div>

        <div className="cell">In-patient</div>
        <div className="cell">Out-patient</div>
        <div className="cell">Accidental Death</div>
        <div className="cell">Benefits</div>
        <div className="cell">Monthly Price</div>
      </div>
    </>
  );
};

export default PremiumTableHeader;
